import axios from "axios";
import { convertUrl } from "../helpers/helper";

const state = {
  modules: [],
  modulesList: [],
  paginationPages: 1,
  paginationCurrentPage: 1,
  validationErrors: [],
  isLoading: false,
};

const mutations = {
  SET_MODULES(state, data) {
    state.modules = data;
  },

  SET_MODULES_LIST(state, data) {
    state.modulesList = data;
  },

  SET_PAGINATION_PAGES(state, data) {
    state.paginationPages = data;
  },

  SET_PAGINATION_CURRENT_PAGE(state, data) {
    state.paginationCurrentPage = data;
  },

  SET_VALIDATION_ERRORS(state, data) {
    state.validationErrors = data;
  },

  SET_IS_LOADING(state, data) {
    state.isLoading = data;
  },
};

const actions = {
  async getModules({ commit }, payload) {
    commit("SET_MODULES", []);
    commit("SET_IS_LOADING", true);
    try {
      let apiUrl = convertUrl("module", payload);
      let { data } = await axios.get(apiUrl);
      if (Array.isArray(data)) {
        commit("SET_MODULES", data);
      } else {
        commit("SET_MODULES", data?.result);
        commit("SET_PAGINATION_PAGES", data?.pages);
      }
    } catch (error) {
      commit("SET_MODULES", []);
    }
    commit("SET_IS_LOADING", false);
  },

  async getModulesList({ commit }, payload) {
    try {
      let apiUrl = convertUrl("module", payload);
      let { data } = await axios.get(apiUrl);
      if (Array.isArray(data)) {
        commit("SET_MODULES_LIST", data);
      }
    } catch (error) {
      commit("SET_MODULES_LIST", []);
    }
  },

  async saveModule({ dispatch, commit }, payload) {
    try {
      await axios.post("module", payload);
      dispatch("getModules", { page: 1 });
    } catch (error) {
      if (error.response.status == 400) {
        commit("SET_VALIDATION_ERRORS", error?.response?.data?.message);
      } else {
        commit("SET_VALIDATION_ERRORS", ["No se pudo realizar está operación"]);
      }
      throw new Error(error);
    }
  },

  async updateModule({ dispatch, commit }, payload) {
    try {
      await axios.put(`module/${payload.id}`, payload);
      dispatch("getModules", { page: 1 });
    } catch (error) {
      if (error.response.status == 400) {
        commit("SET_VALIDATION_ERRORS", error?.response?.data?.message);
      } else {
        commit("SET_VALIDATION_ERRORS", ["No se pudo realizar está operación"]);
      }
      throw new Error(error);
    }
  },

  async deleteModule({ dispatch }, id) {
    try {
      await axios.delete(`module/${id}`);
      dispatch("getModules", { page: 1 });
    } catch (error) {
      throw new Error("No se pudo realizar está operación");
    }
  },

  cleanValidationErrors({ commit }) {
    commit("SET_VALIDATION_ERRORS", []);
  },

  updateCurrentPage({ commit }, page) {
    commit("SET_PAGINATION_CURRENT_PAGE", page);
  },
};

const getters = {
  getModules(state) {
    let items = state.modules.map((item) => {
      return {
        ...item,
        app_name: item?.app_id?.name,
        app_id: item?.app_id?.id,
      };
    });
    return items;
  },
  getModulesList(state) {
    return state.modulesList;
  },

  getPaginationPages(state) {
    return state.paginationPages;
  },

  getValidationErrors(state) {
    return state.validationErrors;
  },
};

const xmodule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default xmodule;
